import { combineReducers } from 'redux';
import show from './show';
import update from './update';
import del from './delete';

export default combineReducers({ show, update, del });
